export enum WizardType {
  EWE_BY_EMAIL = 'eweByEmail',
  DIGITAL_SIGNATURE = 'DigitalSignature'
}
